import React, { useEffect, useState } from "react";
import "./forgetpassword.css";
import { Container, Spinner } from "react-bootstrap";
import { TextField, Typography } from "@mui/material";
import { ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import notify from "../../Notifcation";
import { forgetPasswordaction } from "../../redux/actions/AuthAction";
// import { useNavigate } from "react-router-dom";
const Forgetpassword = () => {
  const [email, setEmail] = useState("");
  // const navigate=useNavigate()
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);

  const handlesubmit = async (e) => {
    e.preventDefault();
    if (email === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    await dispatch(
      forgetPasswordaction({
        email,
      })
    );
    setLoading(false);
    setisPress(false);
  };
  const res = useSelector((state) => state.authReducer.forgetPassword);
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (res.data) {
            notify(res.data.message, "success");
            setTimeout(() => {
              navigate("/login");
            }, 2000);
          }
        } else if (res.status !== 200 || res.status !== 201) {
          if (res.data && res.data.message) {
            notify(res.data.message, "error");
          } else notify("حدث خطأ حاول مرة اخرى", "error");
        }
      }
    }
  }, [loading]);
  return (
    <div className="login">
      <Container>
        <div className="main-log">
          <div className="login-container">
            <h2>هل نسيت كلمة السر..؟</h2>
            <div className="login">
              <TextField
                label={
                  <Typography
                  >
                 البريد الألكتروني
                    <span style={{ color: "red", fontSize: "21px" }}>
                      *
                    </span>
                  </Typography>
                }
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                variant="outlined"
              />

              {loading && isPress ? (
                <button className="buttonadd">
                  <Spinner />
                </button>
              ) : (
                <button className="buttonadd" onClick={handlesubmit}>
                  إرسال
                </button>
              )}
            </div>
          </div>
        </div>
      </Container>
      <ToastContainer />
    </div>
  );
};

export default Forgetpassword;
